import { useI18n } from "../../lib/i18n.jsx";
import { Shield, Users, MapPin, Sparkles } from "lucide-react";
import CountUp from "../CountUp.jsx";

const ICONS = [Shield, Users, MapPin, Sparkles];

export default function Trust() {
  const { t } = useI18n();
  return (
    <section
      id="why"
      data-testid="trust-section"
      className="bg-paper py-20 md:py-28"
    >
      <div className="max-w-[1300px] mx-auto px-5 md:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="font-handwritten text-summer text-2xl md:text-3xl mb-2">
            {t.trust.kicker}
          </p>
          <h2
            className="font-display font-bold text-winter leading-tight mb-4"
            style={{ fontSize: "clamp(2rem, 4.5vw, 3.5rem)" }}
          >
            {t.trust.title}
          </h2>
          <p className="text-lg text-winter/65">{t.trust.subtitle}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.trust.items.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`trust-item-${i}`}
                className="card-soft p-7 text-center"
              >
                <div className="w-14 h-14 rounded-full bg-summer/10 flex items-center justify-center mx-auto mb-5">
                  <Icon className="w-7 h-7 text-summer" strokeWidth={2} />
                </div>
                <p className="font-display font-bold text-summer text-4xl md:text-5xl mb-2 leading-none">
                  <CountUp value={item.stat} />
                </p>
                <h3 className="font-display font-bold text-winter text-lg mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-winter/65 leading-relaxed">
                  {item.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
